"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        button: {
            backgroundColor: 'unset',
            borderStyle: 'none',
            borderWidth: 0,
            cursor: 'pointer',
            fontFamily: theme_1.default.fontFamily,
            padding: 'unset',
            userSelect: 'none',
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
            fontSize: 'inherit',
        },
        marginBottom24: {
            marginBottom: 24,
        },
        titleContainer: {
            alignItems: 'center',
            display: 'flex',
            transition: theme_1.default.transitions.easeOutFast,
        },
        chevron: {
            transform: 'rotate(-90deg)',
            transition: theme_1.default.transitions.easeOutFast,
        },
        chevronExpanded: {
            transform: 'rotate(0deg)',
        },
        marginRight: {
            marginRight: 8,
        },
        title: {
            marginRight: 20,
        },
        titleWidthEdit: {
            marginRight: 12,
        },
        titleWithIcon: {
            marginRight: 20,
        },
        titleWithIconWidthEdit: {
            marginRight: 4,
        },
        editIcon: {
            marginRight: 12,
            marginLeft: 8,
        },
    });
});
